import { useEffect, useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme,useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AssignmentTurnedInRoundedIcon from '@mui/icons-material/AssignmentTurnedInRounded';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import HowToRegSharpIcon from '@mui/icons-material/HowToRegSharp';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import AddIcon from '@mui/icons-material/Add';
import HolidayVillageRoundedIcon from '@mui/icons-material/HolidayVillageRounded';
import ContactsIcon from '@mui/icons-material/Contacts';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import EmergencyShareIcon from '@mui/icons-material/EmergencyShare';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { jwtDecode } from "jwt-decode";
import EmailIcon from "@mui/icons-material/Email"; 
import darklogoImage from "../../components/DarkBackground.webp";
document.addEventListener('DOMContentLoaded', () => {
  // Find the active nav item in the sidebar
  const item = document.getElementsByClassName('navListItemActive')[0];
  if (!item) { return; }
  const bounding = item.getBoundingClientRect();
  if (
    bounding.top >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
    // Already visible.  Do nothing.
  } else {
    // Not visible.  Scroll sidebar.
    item.scrollIntoView({ block: 'center', inline: 'nearest' });
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
});
const userInfo = JSON.parse(localStorage.getItem("userInfo"));



const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}>
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};



const Sidebar = ({ isSidebar, accessLevel }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");
  const[acess, setAccess]=useState("");
  const isLarge = useMediaQuery("(min-width: 1920px)");
  const isUltraWide = useMediaQuery("(max-width: 2560px)");
  const is2XLarge = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 495px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  useEffect(()=>{
    // console.log(" i am executed")
 
    getUserFromToken()
  },[])

  function getUserFromToken() {
    const token = sessionStorage.getItem("authToken");
  
    if (!token) {
      console.error("No token found. User is not authenticated.");
      return null;
    }
  
    try {
      const decoded = jwtDecode(token); // Decode JWT
      // console.log("i am in the sidebar ")


      if (decoded.isAdmin) {
        setAccess("admin");
      } else {
        setAccess("employee");
      }
  
      // console.log(acess);
  
      return decoded; 
      // { email, isAdmin, exp }
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  }

  return (
    <Box
      sx={{
   
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)} icon={isCollapsed ? <MenuOutlinedIcon /> : undefined} style={{ margin: "10px 0 20px 0", color: colors.grey[100], }}
          >
            {!isCollapsed && (
              <Box
                display="flex" justifyContent="space-between" alignItems="center" ml="15px"
              >
                <Box
              component="img"
              src={darklogoImage}
              alt="DevAngles logo – Delivering simple, innovative, and excellent digital IT solutions"
              loading="eager"
              sx={{
                width: 150 , 
                height: 22,
              }}
            />
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && userInfo && (
            <Box mb="25px">
              {/* <Box display="flex" justifyContent="center" alignItems="center">
                <img src={userInfo.photo} alt="User Profile Photo" />
              </Box> */}
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {userInfo.name}
                </Typography>
                {/* <Typography variant="h5" color={colors.blueAccent[500]}>{userInfo.role}</Typography> */}
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>


          {accessLevel !== "admin" && (
            <Item
              title="Dashboard"
              to="/Dashboard"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          )}



  {accessLevel === "admin" && (
    <>
      <Item
        title="Employee"
        to="/material/EmpList"
        icon={<HomeOutlinedIcon />}
        selected={selected}
        setSelected={setSelected}
      />
      <Item
        title="Dashboard Admin"
        to="/dashboard-hrm/"
        icon={<HomeOutlinedIcon />}
        selected={selected}
        setSelected={setSelected}
      />
    </>
  )}

       {/* {acess !== "admin" && ( */}
  
  {/* <Typography
  variant="h6"
  color={colors.greenAccent[300]}
  sx={{ m: "20px 0 5px 20px" }}
>
  Pages
</Typography> */}

  {/* <Item
  title="Projects"
  to="Projects/"
  icon={<AssignmentTurnedInRoundedIcon />}
  selected={selected}
  setSelected={setSelected}
/> */}


{/* 
            <Item
              title="Projects"
              to="Projects/"
              icon={<AssignmentTurnedInRoundedIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}

{/* 
{acess !== "admin" && ( */}
  
{/* <Item
              title="Reports"
              to="Report/"
              icon={<AssessmentOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
{/* 
)}
         */}


{/* {acess !== "admin" && ( */}
  
{/* <Item
              title="Daily"
              to="Daily/"
              icon={<TodayOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
{/*   
  )} */}

             


       <Typography
       variant="h6"
       color={colors.greenAccent[300]}
       sx={{ m: "20px 0 5px 20px" }}
     >
       Your Company
     </Typography>
    





            <Item
            title="My Profile"
            to="/team"
            icon={<PeopleOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
   
             
      
    

{/* {acess !== "admin" && ( */}

<Item
title="Payroll"
to="/employee-payroll"
icon={<PaidOutlinedIcon />}
selected={selected}
setSelected={setSelected}
/>
    
    {/* )} */}
        

  

{/* <Item
title="Calender"
to="/calendar"
icon={<EventAvailableIcon />}
selected={selected}
setSelected={setSelected}
/> */}
    



{/* {acess !== "admin" && ( */}

<Typography
variant="h6"
color={colors.greenAccent[300]}
sx={{ m: "20px 0 5px 20px" }}
>
Leave Section
</Typography>

    
    {/* )} */}

  
       
       


            {/* <Item
              title="Approve Leave"
              to="/ApproveLeave"
              icon={<HowToRegSharpIcon />}
              selected={selected}
              setSelected={setSelected}
            />
              */}

    {accessLevel === "admin" && (
      <Item
        title="Approve Leave"
        to="/ApproveLeave"
        icon={<HowToRegSharpIcon />}
        selected={selected}
        setSelected={setSelected}
      />
    )}

          
        
{/* 
{acess !== "admin" && ( */}

<Item
title="Apply For Leave"
to="/ApplyLeave"
icon={<AddIcon />}
selected={selected}
setSelected={setSelected}
/>

    
    {/* )} */}




{/* {acess !== "admin" && ( */}

    <Item
    title="Leave History"
    to="/AppliedLeaves"
    icon={<HistoryToggleOffOutlinedIcon />}
    selected={selected}
    setSelected={setSelected}
    />
    
    {/* )} */}

       
 
            <Item
              title="Public Holidays"
              to="/PublicHolidays"
              icon={<Diversity3Icon />}
              selected={selected}
              setSelected={setSelected}
            />


{/* 

{acess !== "admin" && ( */}

<Item
title="Attendence"
to="/Attendence"
icon={<DirectionsRunIcon />}
selected={selected}
setSelected={setSelected}
/>
    
    {/* )} */}

 



 

            
            {accessLevel === "admin" && (

<Typography
variant="h6"
color={colors.greenAccent[300]}
sx={{ m: "20px 0 5px 20px" }}
>
Hrm Admin
</Typography>
)}


{accessLevel === "admin" && (
  <Item
    title="Add New Employee"
    to="/Add_Employee"
    icon={<HolidayVillageRoundedIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}

{accessLevel === "admin" && (
  <Item
    title="Add New Job"
    to="/Add_Job"
    icon={<HolidayVillageRoundedIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}



{/* 

{acess === "admin" && (
  <Item
   title="Address Details"
   to="/Add_Address_Details"
   icon={<EmergencyShareIcon />}
   selected={selected}
   setSelected={setSelected}
 />
      
)}

{acess === "admin" && (
  <Item
   title="Bank Details"
   to="/Add_Bank_Details"
   icon={<FolderSharedIcon />}
   selected={selected}
   setSelected={setSelected}
 />
      
)}


{acess === "admin" && (
   <Item
   title="Documents Details"
   to="/Add_document"
   icon={<FolderZipIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)}





{acess === "admin" && (
   <Item
   title="Qualification Details"
   to="/Add_qualification"
   icon={<EventNoteIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)}




{acess === "admin" && (
   <Item
   title="Work Experience  Details"
   to="/Add_workexperience"
   icon={<FolderSharedIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)}



{acess === "admin" && (
   <Item
   title=" Emergency  Contact Details"
   to="/Add_emergency_contact"
   icon={<ContactsIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)} */}


{accessLevel === "admin" && (
  <Item
    title="Job Application"
    to="/job_application"
    icon={<ContactsIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}

{accessLevel === "admin" && (
  <Item
    title="Config"
    to="/config"
    icon={<EmailIcon />} // You can replace this with any icon you prefer
    selected={selected}
    setSelected={setSelected}
  />
)}

{accessLevel === "admin" && (
  <Typography
    variant="h6"
    color={colors.greenAccent[300]}
    sx={{ m: "20px 0 5px 20px" }}
  >
    Leave Admin
  </Typography>
)}

{accessLevel === "admin" && (
  <Item
    title="Add & deduct Leave"
    to="/Add_deduct_leave"
    icon={<EmojiPeopleIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}



{/* {acess === "admin" && (
   <Item
   title="Add Holiday"
   to="/Add_holiday"
   icon={<Diversity3Icon />}
   selected={selected}
   setSelected={setSelected}
 />
)} */}





{accessLevel === "admin" && (
  <Item
    title="Add check-in-out"
    to="/Add_check_in_out"
    icon={<DirectionsRunIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}






{/* {acess === "admin" && (
   <Item
   title="upload csv add-check-in-out"
   to="/upload_csv_check_in_out"
   icon={<FileUploadIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)} */}






{/* {acess === "admin" && (
   <Item
   title="Add-Update Payroll "
   to="/add_payroll"
   icon={<FileUploadIcon />}
   selected={selected}
   setSelected={setSelected}
 />
)}
 */}






{accessLevel === "admin" && (
  <Item
    title="CTC"
    to="/ctc"
    icon={<HolidayVillageRoundedIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}

{accessLevel === "admin" && (
  <Item
    title="Payroll Page"
    to="/payrollpage"
    icon={<HolidayVillageRoundedIcon />}
    selected={selected}
    setSelected={setSelected}
  />
)}



        
  

 

            {/* <Item
              title="Leaves"
              to="/LeaveSection"
              icon={< WorkOffOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
            </Typography>
            {/* <Item
              title="Logout"
              to="/Logout"
              icon={<LogoutIcon />}
              selected={selected}
              setSelected={setSelected}
            /> */}
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
